import React from 'react';

const Info = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 24 24"
  >
    <path
      fill="#A4A4A4"
      fillRule="evenodd"
      d="M12 2.5c5.5 0 10 4.5 10 10s-4.5 10-10 10S2 18 2 12.5s4.5-10 10-10zm0 1c-4.95 0-9 4.05-9 9s4.05 9 9 9 9-4.05 9-9-4.05-9-9-9zm0 7a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-5a1 1 0 0 1 0-2h1zm0-4a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"
    />
  </svg>
);

export default Info;
